<script setup>

import BaseNotification from "@/Components/notifications/BaseNotification.vue";
import ConfirmActionDialog from "@/Components/UI/modals/ConfirmActionDialog.vue";
import {onMounted, ref} from "vue";

defineOptions({
    inheritAttrs: false,
})

const notification = ref(null);
const isMounted = ref(false);
const notify = (flash) => {
    if (flash !== null && notification.value !== null) {
        notification.value.notify(flash);
    }
};

onMounted(() => {
    isMounted.value = true;
    window.addEventListener('notify', (event) => {
        notify({
            type: event.detail.type,
            text: event.detail.text,
            action: event.detail.action,
        })
    });
})
</script>

<template>
    <slot v-if="isMounted"/>
    <BaseNotification ref="notification" v-bind="$attrs"/>
    <ConfirmActionDialog />
</template>
